import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RequestQuickBooksLinkJobMutationVariables = Types.Exact<{
  input: Types.RequestBackgroundJobInput;
}>;


export type RequestQuickBooksLinkJobMutation = { __typename?: 'Mutation', requestBackgroundJob: { __typename?: 'BackgroundJobPayload', backgroundJob?: { __typename?: 'BackgroundJob', jobId: string, status: Types.BackgroundJobStatus, total: number, done: number, failed: number } | null, errors?: Array<{ __typename?: 'ValidationError', message: string }> | null } };


export const RequestQuickBooksLinkJobDocument = new TypedDocumentString(`
    mutation RequestQuickBooksLinkJob($input: RequestBackgroundJobInput!) {
  requestBackgroundJob(input: $input) {
    backgroundJob {
      jobId
      status
      total
      done
      failed
    }
    errors {
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    RequestQuickBooksLinkJob: build.mutation<RequestQuickBooksLinkJobMutation, RequestQuickBooksLinkJobMutationVariables>({
      query: (variables) => ({ document: RequestQuickBooksLinkJobDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useRequestQuickBooksLinkJobMutation } = injectedRtkApi;
